import React from "react";
import styles from "./SuscriptionItem.module.scss";
import { connect } from "react-redux";
import { setPlanId } from "../../store/actions/index";

class SuscriptionItem extends React.Component {
  state = {
    active: false
  };
  toggleClass = () => {
    this.setState({ active: !this.state.active });
  };
  render() {
    const { name, price } = this.props.plan;
    let activeClass = this.props.id === this.props.planID ? styles.active : "";
    let tipoClass = this.props.tipoCard === "pres" ? styles.active : "";
    return (
      <div className={styles.promoContainer}>
        <div className={`${styles.promoBox} ${styles.new} ${this.props.tipoCard === "pres" ? tipoClass : activeClass}`} onClick={() => this.props.setPlanId(this.props.id)}>
          <h3 className={styles.boxSubtitle}>PRUEBA GRATIS POR 30 DÍAS</h3>
          <div className={styles.pricesContainer}>
            {this.props.id === 3 ? <div className={styles.recomendation}>¡RECOMENDADO!</div> : <div className={styles.noReco}></div>}
            <div className={`${styles.pricesDescription} ${this.props.recommended ? `${styles.mensual}` : ""}`}>{name}</div>
            <div className={styles.price}>{price}</div>
            <div className={styles.currency}>U$D</div>
          </div>
          <div className={styles.verProyecto}>
            <span>Ver Proyecto</span>
          </div>

          <div className={styles.verMas}>Conocer Más</div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    planID: state.register.planID
  };
};

export default connect(mapStateToProps, { setPlanId })(SuscriptionItem);
